import React from "react";
import styled from 'styled-components';
import ClaroImage from '../../molecules/ClaroImage'
import ClaroParagraph from '../../atoms/ClaroParagraph'
import { SERVICE_ID_TELCEL_RECARGA } from "../../../constants";

const Container = styled.div`
  width: 100%;
`;

const HeaderPaymentForm = ({
    dataConfigLogo,  
    serviceTitleLabel, 
    isContainerTelcel,
    showAdvancementMiniBanner,
    appSyncValues,
    handleOnclickMiniBanner,
    serviceId
}) => {

    let titleImageStyle =  {
        "align": "center",
        "weight": "bold",
        "margin" : "15px 0px 0px 0px",
        "fontFamily": isContainerTelcel ? "AMX-Bold" : undefined,
        "fontColor": isContainerTelcel ? "#0f0f0f" : undefined,
     }
    const { banks } = appSyncValues
    return(
        <Container>
            {
                !isContainerTelcel && showAdvancementMiniBanner && banks ? 
                    <img 
                        src={
                            serviceId === SERVICE_ID_TELCEL_RECARGA ? 
                                banks[0].properties.INF_URL_ADVANCE_PAYMENT_MINIBANNER :
                                banks[0].properties.INF_URL_BUY_PAYMENT_MINIBANNER
                        } 
                        alt="Logo" 
                        style={{width: "-webkit-fill-available"}}
                        onClick={handleOnclickMiniBanner}
                    /> : 
                    <></>
            }
            
            <ClaroParagraph  {...titleImageStyle} >
                {serviceTitleLabel}
            </ClaroParagraph>
            <ClaroImage {...dataConfigLogo} />
        </Container>
    )
}


export default HeaderPaymentForm;